export enum Api {
  CODAQ_API_PROD = 'https://service.codaq.it/api/webapp/',
  CODAQ_API_DEV = 'https://service.dev.codaq.cloud/apiwebapp/',

  MEDIA_API_PROD = 'https://service.codaq.it/api/media/',
  MEDIA_API_DEV = 'https://service.dev.codaq.cloud/apimedia/',

  EXTRA_PARAMS_API_PROD = 'https://service.codaq.it/api/extraparam/',
  EXTRA_PARAMS_API_DEV = 'https://service.dev.codaq.cloud/apiextraparam/',

  STATS_API_PROD = 'https://stats.codaq.it/apistats/',
  STATS_API_DEV = 'https://stats.codaq.it/apistats/',

  AUTH_API_PROD = 'https://auth.codaq.it/',
  // Relativo: passa dal proxy dev di ng serve (proxy.conf.json) verso localhost:8080,
  // cosi' resta same-origin per il browser (niente problemi SameSite/CORS in locale).
  AUTH_API_DEV = '/',
}
